export var SourceFields;
(function (SourceFields) {
    SourceFields["id"] = "id";
    SourceFields["source"] = "source";
    SourceFields["viewType"] = "viewType";
    SourceFields["lineType"] = "lineType";
    SourceFields["color"] = "color";
    SourceFields["view"] = "view";
    SourceFields["timing"] = "timing";
})(SourceFields || (SourceFields = {}));
export var SourceSourceFields;
(function (SourceSourceFields) {
    SourceSourceFields["_variableName"] = "_variableName";
    SourceSourceFields["_sourceName"] = "_sourceName";
    SourceSourceFields["type"] = "type";
    SourceSourceFields["simulationId"] = "simulationId";
    SourceSourceFields["_optimizationEnabled"] = "_optimizationEnabled";
    SourceSourceFields["optimizationId"] = "optimizationId";
    SourceSourceFields["insightId"] = "insightId";
    SourceSourceFields["inputSetId"] = "inputSetId";
    SourceSourceFields["timing"] = "timing";
    SourceSourceFields["outputId"] = "outputId";
    SourceSourceFields["isFinal"] = "isFinal";
    SourceSourceFields["processDataId"] = "processDataId";
    SourceSourceFields["variableType"] = "variableType";
    SourceSourceFields["customVariableId"] = "customVariableId";
    SourceSourceFields["adjustmentId"] = "adjustmentId";
    SourceSourceFields["liquid"] = "liquid";
    SourceSourceFields["target"] = "target";
    SourceSourceFields["units"] = "units";
})(SourceSourceFields || (SourceSourceFields = {}));
